import React, { useEffect, useState } from "react";
import "./sheets.css";
import SheetsHome from "./views/SheetsHome.jsx";
import JobHome from "./views/JobHome.jsx";
import Groups from "./views/Groups.jsx";
import Picker from "./views/Picker.jsx";
import Proof from "./views/Proof.jsx";
import Send from "./views/Send.jsx";
import Sent from "./views/Sent.jsx";

/**
 * Preview Sheets — slice 1 (capture-sheet skeleton against seeded data).
 *
 * Mounted from src/App.jsx when activeApp === "sheets". This is the v1
 * capture-sheet branch of the approved walkthrough mockup
 * (docs/sheets/preview-sheets-mockup.html), one screen at a time:
 *
 *   home → job → groups → picker → proof → send
 *
 * Model Previews (the second door on the job screen) is v2 — present but
 * disabled this slice. Drill-down is a flat state machine: each screen answers
 * one question (build-plan §1.6); breadcrumbs are doors, back buttons name
 * their destination. There is no per-screen topbar — the suite's AppTopbar
 * sits above this, same as Ingest.
 */
export default function SheetsApp({ navClickTick }) {
  // The whole flow is a {screen, jobId, jobLabel, groupId} tuple. jobLabel is
  // carried so breadcrumbs/back read in plain language without a job re-fetch.
  const [nav, setNav] = useState({ screen: "home", jobId: null, jobLabel: null, groupId: null });

  // Any topbar "Sheets" click returns to the front door (same pattern as Ingest).
  useEffect(() => { setNav({ screen: "home", jobId: null, jobLabel: null, groupId: null }); }, [navClickTick]);

  const go = (screen, patch = {}) => {
    setNav((n) => ({ ...n, screen, ...patch }));
    if (typeof window !== "undefined") window.scrollTo(0, 0);
  };

  const common = { nav, go };

  return (
    <div className="sheets-root">
      {nav.screen === "home" && <SheetsHome {...common} />}
      {nav.screen === "job" && <JobHome {...common} />}
      {nav.screen === "groups" && <Groups {...common} />}
      {nav.screen === "picker" && <Picker {...common} />}
      {nav.screen === "proof" && <Proof {...common} />}
      {nav.screen === "send" && <Send {...common} />}
      {nav.screen === "sent" && <Sent {...common} />}
    </div>
  );
}
